var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_1090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2.99992H13V14.4999C13 14.7083 12.9609 14.9036 12.8828 15.0859C12.8047 15.2681 12.6979 15.427 12.5625 15.5624C12.4271 15.6978 12.2682 15.8046 12.0859 15.8827C11.9036 15.9609 11.7083 15.9999 11.5 15.9999H3.5C3.29167 15.9999 3.09635 15.9609 2.91406 15.8827C2.73177 15.8046 2.57292 15.6978 2.4375 15.5624C2.30208 15.427 2.19531 15.2681 2.11719 15.0859C2.03906 14.9036 2 14.7083 2 14.4999V2.99992H1V1.99992H5V0.999919C5 0.859294 5.02604 0.729085 5.07812 0.609294C5.13021 0.489502 5.20052 0.385335 5.28906 0.296794C5.3776 0.208252 5.48438 0.135335 5.60938 0.0780436C5.73438 0.0207519 5.86458 -0.00528971 6 -8.13801e-05H9C9.14062 -8.13801e-05 9.27083 0.0259603 9.39062 0.0780436C9.51042 0.130127 9.61458 0.200439 9.70312 0.288981C9.79167 0.377523 9.86458 0.484294 9.92188 0.609294C9.97917 0.734294 10.0052 0.864502 10 0.999919V1.99992H14V2.99992ZM6 1.99992H9V0.999919H6V1.99992ZM12 2.99992H3V14.4999C3 14.6353 3.04948 14.7525 3.14844 14.8515C3.2474 14.9504 3.36458 14.9999 3.5 14.9999H11.5C11.6354 14.9999 11.7526 14.9504 11.8516 14.8515C11.9505 14.7525 12 14.6353 12 14.4999V2.99992ZM7 12.9999H6V4.99992H7V12.9999ZM9.39062 12.9999H8.39062V4.99992H9.39062V12.9999Z",
    fill: "#202020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_1090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.92a82415464c90733e8de50b8f71300e.svg";
export { ForwardRef as ReactComponent };